// import React from 'react';
// import John from '../assets/male1.jpg'
// import Sarah from '../assets/fem1.jpg'
// import Michael from '../assets/male2.jpg'
// import { motion } from "motion/react"
// function mgmt2() {
//     return (
// <motion.section  initial={{ opacity: 0, y: 50 }}
//   whileInView={{ opacity: 1, y: 0 }}
//   transition={{
//     duration: 0.8,
//     ease: "easeOut"
//   }}
//   viewport={{
//     once: true,
//     amount: 0.3
//   }}>
//         <div className='pb-5' style={{backgroundColor:'var(--charcoal)'}}>
//             <div className='' style={{paddingLeft:'290px', paddingTop:'35px'}}>
//              <div className="section-label" style={{color:'white'}}>Leadership</div>
//     <h2 className="section-title" style={{color:'white'}}>Management Team</h2>
//     <div class="divider-gold"></div>
//               <p style={{ fontSize: '.9rem', color: 'white', maxWidth: '560px', marginBottom: '48px', lineHeight: 1.8 }}>
//     Built by Experience. Driven by Innovation.
//                 </p>
//                 </div>
//             <div className='row align-items-center'>
//                     <div className='col-12 col-lg-6 my-3 text-center'>
//                         {/* box-shadow: 0px 6px 10px white */}
//                     <img src={John} style={{maxWidth:'300px', maxHeight:'300px', boxShadow:'0px 6px 10px white'}}/>
//                 </div>
//                 <div className='col-12 col-lg-6 my-3 biocards text-center' style={{padding:'0px 125px'}}>
//                     <h2 className='fw-bold text-white'>John Smith</h2>
//                     <h5 style={{ color: 'var(--gold)' }}>Chief Executive Officer</h5>
//                     <h6 className='text-white'>John Smith has over 20 years of experience leading organizations and developing strategic growth initiatives. He has extensive experience in operations, acquisitions, and building high-performing teams.</h6>
//                     </div>
//             </div>
//                 <div className='row align-items-center'>
//                       <div className='col-12 col-lg-6 my-3 text-center order-1 order-lg-2'>
//                     <img src={Sarah} style={{maxWidth:'300px', maxHeight:'300px', boxShadow:'0px 6px 10px white'}}/>
//                 </div>
//                  <div className='col-12 col-lg-6 my-3 biocards text-center order-2 order-lg-1' style={{padding:'0px 125px'}}>
//                     <h2 className='fw-bold text-white'>Sarah Johnson</h2>
//                     <h5 style={{ color: 'var(--gold)' }}>Chief Operating Officer</h5>
//                     <h6 className='text-white'>Sarah Johnson specializes in operational execution, process improvement, and scaling companies through disciplined management practices. She has successfully managed teams across multiple industries.</h6>
//                     </div>
              
               
//             </div>
//              <div className='row align-items-center'>
//                 <div className='col-12 col-lg-6 my-3 text-center'>
//                     <img src={Michael} style={{maxWidth:'300px', maxHeight:'300px', boxShadow:'0px 6px 10px white'}}/>
//                 </div>
//                 <div className='col-12 col-lg-6 my-3 biocards text-center' style={{padding:'0px 125px'}}>
//                     <h2 className='fw-bold text-white'>Michael Williams</h2>
//                     <h5 style={{ color: 'var(--gold)' }}>Chief Financial Officer</h5>
//                     <h6 className='text-white'>Michael Williams brings extensive financial leadership experience including capital strategy, financial planning, acquisitions, and investor relations.</h6>
//                     </div>
//             </div>
//             </div>
//             </motion.section>
//     )
// }

// export default mgmt2

import React from 'react';

import John from '../assets/male1.jpg';
import Sarah from '../assets/fem1.jpg';
import Michael from '../assets/male2.jpg';

import { motion } from "motion/react";

import './management.css';


function Mgmt2() {

  const team = [
    {
      name: "John Smith",
      title: "Chief Executive Officer",
      image: John,
      bio: "John Smith has over 20 years of experience leading organizations and developing strategic growth initiatives. He has extensive experience in operations, acquisitions, and building high-performing teams.",
      number: "01"
    },
    {
      name: "Sarah Johnson",
      title: "Chief Operating Officer",
      image: Sarah,
      bio: "Sarah Johnson specializes in operational execution, process improvement, and scaling companies through disciplined management practices. She has successfully managed teams across multiple industries.",
      number: "02"
    },
    {
      name: "Michael Williams",
      title: "Chief Financial Officer",
      image: Michael,
      bio: "Michael Williams brings extensive financial leadership experience including capital strategy, financial planning, acquisitions, and investor relations.",
      number: "03"
    }
  ];


  return (

    <motion.section
      id="team"

      className="management-section"

      initial={{ opacity: 0, y: 50 }}

      whileInView={{ opacity: 1, y: 0 }}

      transition={{
        duration: 0.8,
        ease: "easeOut"
      }}

      viewport={{
        once: true,
        amount: 0.3
      }}
    >


      {/* Background red accents */}

      <div className="management-glow management-glow-left"></div>

      <div className="management-glow management-glow-right"></div>


      <div className="container position-relative">


        {/* SECTION HEADER */}

        <div className="management-header">

          <div className="section-label management-label">

            <span className="management-label-line"></span>

            LEADERSHIP

          </div>


          <h2 className="section-title management-title">

            Management Team

          </h2>


          <div className="management-title-line"></div>


          <p className="management-intro">

            Built by Experience. Driven by Innovation.

          </p>

        </div>


        {/* TEAM MEMBERS */}

        <div className="management-team">


          {team.map((member, index) => (

            <motion.div

              className={`row align-items-center management-member ${
                index % 2 !== 0 ? "management-member-reverse" : ""
              }`}

              key={member.number}

              initial={{
                opacity: 0,
                y: 35
              }}

              whileInView={{
                opacity: 1,
                y: 0
              }}

              transition={{
                duration: 0.7,
                delay: 0.1
              }}

              viewport={{
                once: true,
                amount: 0.25
              }}
            >


              {/* IMAGE */}

              <div
                className={`col-12 col-lg-6 management-image-col ${
                  index % 2 !== 0
                    ? "order-1 order-lg-2"
                    : "order-1"
                }`}
              >

                <div className="management-image-wrapper">

                  {/* <div className="management-image-number">

                    {member.number}

                  </div> */}


                  <div className="management-image-accent"></div>


                  <img
                    src={member.image}
                    alt={member.name}
                    className="management-image"
                  />

                </div>

              </div>


              {/* BIO */}

              <div
                className={`col-12 col-lg-6 management-bio-col ${
                  index % 2 !== 0
                    ? "order-2 order-lg-1"
                    : "order-2"
                }`}
              >

                <div className="management-bio">

                  <div className="management-role">

                    {member.title}

                  </div>


                  <h2>

                    {member.name}

                  </h2>


                  <div className="management-bio-line"></div>


                  <p>

                    {member.bio}

                  </p>

                </div>

              </div>

            </motion.div>

          ))}

        </div>

      </div>

    </motion.section>

  );

}


export default Mgmt2;